import './wiz-textfield.scss';
import React from 'react';

export default function WizTextfield({ placeholder, value, onChange, className = '', ...props }) {
  return (
    <div className="wiz-textfield-wrapper">
      <input
        type="text"
        className={`wiz-textfield ${className}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        {...props}
      />
    </div>
  );
}
  